var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223.7 143.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linejoin:bevel;stroke-width:10px;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5,
    y: 5,
    width: 213.7,
    height: 133.45,
    rx: 19.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2 keyBtn",
    x: 36.69,
    y: 65.65,
    width: 22,
    height: 22,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2 keyBtn",
    x: 69.03,
    y: 65.65,
    width: 22,
    height: 22,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2 keyBtn",
    x: 101.88,
    y: 65.65,
    width: 22,
    height: 22,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2 keyBtn",
    x: 134.22,
    y: 65.65,
    width: 22,
    height: 22,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2 keyBtn",
    x: 34.9,
    y: 30.08,
    width: 22,
    height: 22,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2 keyBtn",
    x: 67.24,
    y: 30.08,
    width: 22,
    height: 22,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2 keyBtn",
    x: 100.09,
    y: 30.08,
    width: 22,
    height: 22,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2 keyBtn",
    x: 132.43,
    y: 30.08,
    width: 22,
    height: 22,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2 keyBtn",
    x: 165.45,
    y: 30.08,
    width: 22,
    height: 22,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2 spaceBtn",
    x: 74.02,
    y: 100.31,
    width: 75.66,
    height: 21.45,
    rx: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 29.17,
    cy: 114.95,
    r: 8.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2 enterBtn",
    x: 172.6,
    y: 74.27,
    width: 22,
    height: 38.3,
    rx: 6.71,
    transform: "translate(367.2 186.84) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.68dc830368c38d26ca3210bc17f5856c.svg";
export { ForwardRef as ReactComponent };